import { SUBSCRIPTION_MESSAGE_TYPE } from 'util/config/constant';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';

/**
 * Get description
 * @param {*} type
 * @param {*} messageKey
 */
export const getDescription = (type, messageKey, t) => {
  if (type === SUBSCRIPTION_MESSAGE_TYPE.NOTIFICATION) {
    return t(`${messageKey}.description`, {
      ns: TRANSLATION_NAMESPACES.NOTIFICATION_CODES
    });
  }

  if (type === SUBSCRIPTION_MESSAGE_TYPE.CLEANING_REPORT) {
    return t(`cleaningReportMessageMapping.${messageKey}`);
  }

  return '';
};
